define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const util = require('utils');
    const Class = require('Class');
    const AbstractProvider = require('common/addressLookupSwiss/sourceProviders/abstractProvider');

    module.exports = Class.create(AbstractProvider, {
        zipRegEx: /^[0-9]*$/,
        cityRegEx: /^([^0-9]*)$/,
        sortBy: '',
        searchText: '',

        /**
         * @override
         */
        prepareRequest: function(searchText, prevSearchResult) {
            const data = AbstractProvider.prototype.prepareRequest(searchText, prevSearchResult);
            const zipCode = this.zipRegEx.test(searchText) ? searchText : '';
            const townName = this.cityRegEx.test(searchText) ? searchText : '';
            this.sortBy = townName && 'city';
            this.searchText = searchText.toLowerCase();

            data.request = {
                ...data.request,
                Zipcode: zipCode,
                TownName: townName
            };

            return data;
        },

        /**
         * @override
         */
        isValid: function(searchText) {
            return searchText.length >= 2 && (this.zipRegEx.test(searchText) || this.cityRegEx.test(searchText));
        },

        /**
         * @override
         */
        sort: function(rows) {
            var aReplacer = 'a1';
            var uReplacer = 'u2';
            var oReplacer = 'o3';
            var AReplacer = 'A1';
            var UReplacer = 'U2';
            var OReplacer = 'O3';
            var eReplacer = 'e4';
            var EReplacer = 'E4';
            var aUmlaut = 'ä';
            var uUmlaut = 'ü';
            var oUmlaut = 'ö';
            var AUmlaut = 'Ä';
            var UUmlaut = 'Ü';
            var OUmlaut = 'Ö';
            var eUmlaut = 'è';
            var EUmlaut = 'È';
            var substrings = ['ä', 'ü', 'ö', 'Ä', 'Ü', 'Ö', 'è', 'È'];

            var input = this.lastInput[0].toLowerCase();
            var inputLength = input.length;
            if (isNaN(input)) {
                if (!substrings.some(input.includes.bind(input))) {
                    var replaceRow = _.each(rows, function(item) {
                        var city = item.city;
                        item.city = city
                            .replace(uUmlaut, uReplacer)
                            .replace(aUmlaut, aReplacer)
                            .replace(oUmlaut, oReplacer)
                            .replace(eUmlaut, eReplacer)
                            .replace(UUmlaut, UReplacer)
                            .replace(AUmlaut, AReplacer)
                            .replace(OUmlaut, OReplacer)
                            .replace(EUmlaut, EReplacer);
                    });

                    rows = _.filter(replaceRow, function(el) {
                        var firstChar = el.city.substring(0, inputLength).toLowerCase();
                        input.replace(uUmlaut, uReplacer)
                            .replace(aUmlaut, aReplacer)
                            .replace(oUmlaut, oReplacer)
                            .replace(eUmlaut, eReplacer)
                            .replace(UUmlaut, UReplacer)
                            .replace(AUmlaut, AReplacer)
                            .replace(OUmlaut, OReplacer)
                            .replace(EUmlaut, EReplacer);
                        if (input === firstChar) {
                            return true;
                        }
                    });

                    _.each(rows, function(row) {
                        var city = row.city;
                        row.city = city
                            .replace(uReplacer, uUmlaut)
                            .replace(aReplacer, aUmlaut)
                            .replace(oReplacer, oUmlaut)
                            .replace(eReplacer, eUmlaut)
                            .replace(UReplacer, UUmlaut)
                            .replace(AReplacer, AUmlaut)
                            .replace(OReplacer, OUmlaut)
                            .replace(EReplacer, EUmlaut);
                    });
                } else {
                    rows = _.filter(rows, function(el) {
                        var firstChar = el.city.substring(0, inputLength).toLowerCase();
                        input.replace(uUmlaut, uReplacer)
                            .replace(aUmlaut, aReplacer)
                            .replace(oUmlaut, oReplacer)
                            .replace(eUmlaut, eReplacer)
                            .replace(UUmlaut, UReplacer)
                            .replace(AUmlaut, AReplacer)
                            .replace(OUmlaut, OReplacer)
                            .replace(EUmlaut, EReplacer);
                        if (input === firstChar) {
                            return true;
                        }
                    });
                }
            }

            return rows.sort(function(row1, row2) {
                return util.predicate.stringPredicate(row1.zip, row2.zip);
            });
        },

        /**
         * @override
         */
        format: function(row) {
            return this.highlightResult(row.zip + ' ' + row.city);
        }
    });
});
